export default {
    AUTH_LOGGED_IN: 'AUTH_LOGGED_IN',
    AUTH_LOGGED_OUT: 'AUTH_LOGGED_OUT',
};
